export default "__VITE_ASSET__CgKIqk3d__"